export default __webpack_public_path__ + "static/abcworld-impact-report-2020-a532c7555ea678c948d5a4274e921ec4.pdf";